import React, { useState, useEffect, useMemo } from "react";
import { Space, Row } from "@masterteam/mt-design-react";
import { FormattedMessage } from "react-intl";
import {
  Switch,
  Route,
  Redirect,
  withRouter,
  Link,
  useHistory,
} from "react-router-dom";

import MyTasks from "./MyTasks";
import MyRequests from "./MyRequests";
import Archive from "./Archive";

import { ReactComponent as MyTasksIcon } from "../../assets/images/approvals-icon.svg";
import { ReactComponent as MyRequestsIcon } from "../../assets/images/requests-icon.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/images/archive.svg";
import { ReactComponent as CalenderIcon } from "../../assets/images/calender.svg";

import "./style.scss";

const TaskCenter = ({ location }) => {
  const history = useHistory();
  const [index, setIndex] = useState(0);

  const routes = useMemo(
    () => [
      {
        name: "task-center.my-current-tasks",
        path: `/splus/task-center/my-current-tasks`,
        component: () => <MyTasks />,
        icon: <MyTasksIcon className="tab-icon" />,
      },
      {
        name: "task-center.my-requests",
        path: `/splus/task-center/my-requests`,
        component: () => <MyRequests />,
        icon: <MyRequestsIcon className="tab-icon" />,
      },
      {
        name: "task-center.archive",
        path: `/splus/task-center/archive`,
        component: () => <Archive />,
        icon: <ArchiveIcon className="tab-icon" />,
      },
    ],
    []
  );

  useEffect(() => {
    const { pathname } = location;

    setIndex(
      routes.findIndex((item) => {
        return item.path === pathname;
      })
    );
  }, [location]);

  return (
    <div className="task-center-container">
      <Row
        align="center"
        justify="between"
        className="task-center-container__title cursor"
      >
        <FormattedMessage id="task-center" />
        <CalenderIcon
          onClick={() => {
            history.push("/splus/task-center/calendar");
          }}
        />
      </Row>

      <Space className="tabs-container" direction="vertical">
        <div className="tabs d-flex">
          {routes.map((item, i) => (
            <Link to={item?.path} key={i}>
              <Space
                size="medium"
                align="center"
                onClick={() => setIndex(i)}
                className={`tab-menu-item ${index === i && "active"}`}
              >
                <div className="tab-menu-item_icon">{item?.icon}</div>
                <FormattedMessage id={item.name} defaultMessage={item.name} />
              </Space>
            </Link>
          ))}
        </div>

        <div className="tab-content-container">
          <Switch>
            {routes.map(({ path, name, component }) => (
              <Route path={path} name={name} component={component} key={name} />
            ))}

            <Redirect from="/" to={`/splus/task-center/my-current-tasks`} />
          </Switch>
        </div>
      </Space>
    </div>
  );
};

export default withRouter(TaskCenter);
